import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import heroBg from './assets/bgimg.jpg'
import LOGO_PATH from "./assets/logo.png";
import team1 from "./assets/team1.png";
import team2 from "./assets/team2.jpg";
import team3 from "./assets/team3.png";
import team4 from "./assets/team4.jpg";
const WA_PHONE = "918637435166";
const WA_MESSAGE = "Hello%20Varnam%2C%20I%20would%20like%20to%20discuss%20a%20project.";



export default function APP() {
  const [navOpen, setNavOpen] = useState(false);
  const cardRefs = useRef([]);
  const heroRef = useRef(null);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => entries.forEach((entry) => entry.isIntersecting && entry.target.classList.add("in-view")),
  //     { threshold: 0.12 }
  //   );
  //   cardRefs.current.forEach((el) => el && observer.observe(el));

  //   const handleMove = (e) => {
  //     const el = heroRef.current;
  //     if (!el) return;
  //     const w = window.innerWidth, h = window.innerHeight;
  //     const x = (e.clientX - w / 2) / w, y = (e.clientY - h / 2) / h;
  //     el.style.setProperty("--mx", `${x * 14}px`);
  //     el.style.setProperty("--my", `${y * 10}px`);
  //   };
  //   window.addEventListener("mousemove", handleMove);
  //   return () => {
  //     window.removeEventListener("mousemove", handleMove);
  //     observer.disconnect();
  //   };
  // }, []);

  const whatsappUrl = `https://wa.me/${WA_PHONE}?text=${WA_MESSAGE}`;
  const closeNav = () => setNavOpen(false);





  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);






  useEffect(() => {
    const aboutSection = document.querySelector("#about");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      { threshold: 0.15 }
    );

    if (aboutSection) observer.observe(aboutSection);

    return () => observer.disconnect();
  }, []);


  useEffect(() => {
    const elements = document.querySelectorAll(".fade-up");
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
          else entry.target.classList.remove("visible");
        });
      },
      { threshold: 0.15 }
    );
    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const [current, setCurrent] = useState(0);
  const aboutImages = [
    { src: team1, alt: "Office Culture" },
    { src: team2, alt: "Innovation at Work" },
    { src: team3, alt: "Creative Teamwork" },
    { src: team4, alt: "Women-Led Leadership" },
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % aboutImages.length);
    }, 3500); // every 3.5 seconds
    return () => clearInterval(interval);
  }, []);



  const services = [
    {
      icon: "bi-cloud-upload",
      title: "Cloud Architecture",
      desc: "Designing scalable and secure cloud infrastructure on AWS, Azure, and GCP for performance and uptime."
    },
    {
      icon: "bi-diagram-3",
      title: "DevOps Automation",
      desc: "Automating CI/CD pipelines and managing container deployments with Docker and Kubernetes."
    },
    {
      icon: "bi-bar-chart",
      title: "Data Engineering",
      desc: "Building efficient data pipelines and analytics workflows for business intelligence."
    },
    {
      icon: "bi-code-slash",
      title: "Web Development",
      desc: "Creating responsive, SEO-optimized websites that reflect your brand and deliver performance."
    },
    {
      icon: "bi-telephone-forward",
      title: "BPO & Telecalling",
      desc: "Providing multilingual customer support and lead generation with a human touch."
    },
    {
      icon: "bi-lightning-charge",
      title: "Digital Transformation",
      desc: "Modernizing legacy systems and implementing automation for smarter business operations."
    }
  ];






  return (
    <div className="app-root">
      {/* NAVBAR */}
      {/* <nav className="navbar navbar-expand-md fixed-top top-nav" role="navigation" aria-label="main">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="#top" onClick={closeNav}>
            <img src={LOGO_PATH} alt="logo" onError={(e) => e.target.style.display = 'none'} />
          </a>
          <button className="navbar-toggler" onClick={() => setNavOpen(!navOpen)} style={{ border: 0, background: 'transparent' }} aria-label="Toggle navigation">
            <svg width="28" height="20" viewBox="0 0 28 20" aria-hidden>
              <rect y="1" width="28" height="2" rx="1" fill="#9f9393" opacity="0.95" />
              <rect y="9" width="28" height="2" rx="1" fill="#9f9393" opacity="0.95" />
              <rect y="17" width="28" height="2" rx="1" fill="#9f9393" opacity="0.95" />
            </svg>
          </button>
          <div className={`nav-collapse ${navOpen ? "react-show" : ""}`}>
            <ul className="navbar-nav ms-auto gap-3" style={{ alignItems: 'center' }}>
              <li><a className="nav-link" href="#services" onClick={closeNav}>Services</a></li>
              <li><a className="nav-link" href="#about" onClick={closeNav}>About</a></li>
              <li><a className="nav-link" href="#contact" onClick={closeNav}>Contact</a></li>
            </ul>
          </div>
        </div>
      </nav> */}



      <nav className="navbar navbar-expand-md fixed-top top-nav" role="navigation" aria-label="main">
        <div className="container d-flex justify-content-between align-items-center">

          {/* BRAND LOGO */}
          <a className="navbar-brand" href="#top" onClick={closeNav}>
            <img
              src={LOGO_PATH}
              alt="Varnam Solutions"
              className="brand-logo"
              onError={(e) => (e.target.style.display = "none")}
            />
          </a>

          {/* MOBILE TOGGLER */}
          <button
            className="navbar-toggler"
            onClick={() => setNavOpen(!navOpen)}
            style={{ border: 0, background: "transparent" }}
            aria-label="Toggle navigation"
          >
            <svg width="28" height="20" viewBox="0 0 28 20" aria-hidden>
              <rect y="1" width="28" height="2" rx="1" fill="#9f9393" opacity="0.95" />
              <rect y="9" width="28" height="2" rx="1" fill="#9f9393" opacity="0.95" />
              <rect y="17" width="28" height="2" rx="1" fill="#9f9393" opacity="0.95" />
            </svg>
          </button>

          {/* NAVIGATION LINKS */}
          <div className={`nav-collapse ${navOpen ? "react-show" : ""}`}>
            <ul className="navbar-nav ms-auto gap-3" style={{ alignItems: "center" }}>
              <li><a className="nav-link" href="#services" onClick={closeNav}>Services</a></li>
              <li><a className="nav-link" href="#about" onClick={closeNav}>About</a></li>
              <li><a className="nav-link" href="#whyus" onClick={closeNav}>Why Choose Us</a></li>
              <li><a className="nav-link" href="#contact" onClick={closeNav}>Contact</a></li>
            </ul>
          </div>
        </div>
      </nav>


      <header
        className="hero"
        id="top"
        ref={heroRef}
        role="banner"
        aria-label="Hero section"
        style={{
          // linear-gradient(135deg, rgba(255,106,0,0.75), rgba(255,184,107,0.65)), 
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="hero-inner" style={{ width: "100%" }}>
          <div
            className="section-slab slab-hero"
            style={{
              background: "transparent",
              boxShadow: "none",
              margin: 0,
              padding: 0,
              maxWidth: "100%",
            }}
          >
            <div className="container hero-inner">
              <div className="row align-items-center gx-4">
                <div className="col-lg-6">
                  <div
                    className="hero-card"
                    style={{
                      background: "rgba(255, 255, 255, -0.92)",
                      backdropFilter: "blur(5px)",
                      border: "1px solid rgba(255, 255, 255, 0.25)",
                      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
                      borderRadius: "14px",
                      padding: "22px",
                    }}
                  >
                    {/* className="headline"  */}
                    <div className="headline">
                      Empowering Businesses. Elevating Possibilities.
                    </div>
                    <p className="subhead">
                      Varnam Solutions is a women-led technology and outsourcing company
                      from Tamil Nadu, India. We partner with startups, educational
                      institutions, and enterprises to build smart, reliable, and
                      human-centered digital systems.
                    </p>

                    <p className="subhead">
                      From cloud automation to communication services, we help businesses
                      grow through technology that’s affordable, scalable, and built with
                      heart.
                    </p>

                    <div className="mt-4 d-flex gap-2 flex-wrap">
                      <a href="#contact" className="btn cta-primary" onClick={closeNav}>
                        Request a Consultation
                      </a>
                      <a href="#services" className="btn cta-outline" onClick={closeNav}>
                        Our Services
                      </a>
                    </div>
                  </div>
                </div>


                <div className="col-lg-6 d-flex align-items-center justify-content-center">
                  <div className="hero-fade-text-wrapper">
                    <div className="hero-fade-text">
                      <span>Empowering brands through<br />cloud and innovation.</span>
                      <span>Delivering trust, technology,<br />and transformation.</span>
                      <span>Driven by women.<br />Defined by reliability.</span>
                      <span>Building smart systems<br />with human touch.</span>
                    </div>
                  </div>
                </div>






              </div>
            </div>
          </div>
        </div>
      </header>





      <section id="services" className="section-slab slab-services-light text-center py-5">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Delivering reliable technology, communication, and digital solutions designed for your business growth.
          </p>

          <div className="row g-4 mt-4 justify-content-center">
            {services.map((s, idx) => (
              <div key={idx} className="col-sm-6 col-lg-4 fade-up">
                <div className="service-card-clean">
                  <div className="service-icon">
                    <i className={`bi ${s.icon}`}></i>
                  </div>
                  <h5>{s.title}</h5>
                  <p>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section id="about" className="about-section">
        <div className="section-slab slab-about">
          <div className="container-fluid px-lg-5">
            <div className="row align-items-center gy-4">
              {/* Left side — image */}
              <div className="col-lg-6 text-center about-visual">
                <div className="about-carousel">
                  {aboutImages.map((img, i) => (
                    <img
                      key={i}
                      src={img.src}
                      alt={img.alt}
                      className={`carousel-img ${i === current ? "active" : ""}`}
                    />
                  ))}
                </div>
              </div>


              {/* Right side — content */}
              <div className="col-lg-6 about-text">
                <h2
                  className="fw-bold mb-3"
                  style={{ color: "var(--brand-1)", fontSize: "2.2rem" }}
                >
                  Who We Are
                </h2>
                <p style={{ color: "#333", lineHeight: 1.8, fontSize: "1.05rem" }}>
                  Varnam Solutions is a women-led technology and outsourcing company
                  from Tamil Nadu, India. We bring color and creativity to technology
                  — empowering startups, educational institutions, and enterprises
                  with digital innovation.
                </p>

                <p style={{ color: "#555", lineHeight: 1.8 }}>
                  From Cloud & DevOps solutions to customer communication and software
                  development, we combine expertise with empathy. Our focus is on
                  reliability, scalability, and a human-centered approach to
                  technology.
                </p>

                <ul
                  style={{
                    listStyleType: "none",
                    padding: 0,
                    color: "#555",
                    marginTop: "1rem",
                    fontSize: "1rem",
                    lineHeight: "1.8",
                  }}
                >
                  <li>✔ MSME & Udyam Registered Company</li>
                  <li>✔ Women-Led Startup from Tamil Nadu</li>
                  <li>✔ Expertise in Cloud, DevOps, and Digital Transformation</li>
                </ul>

                {/* Founder Inline Highlight */}
                <div className="founder-inline mt-5">
                  <div className="d-flex align-items-center gap-3">
                    {/* <img
                      src="https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=600"
                      alt="Founder Suganya A"
                      className="founder-inline-photo"
                    /> */}
                    <div>
                      <h5 className="founder-inline-name mb-0">Suganya A</h5>
                      <p className="founder-inline-title mb-1">
                        Founder & CEO — Varnam Solutions
                      </p>
                      <p className="founder-inline-quote mb-0">
                        “Making technology more human, simple, and inclusive.”
                      </p>
                    </div>
                  </div>
                </div>

                {/* <a href="#contact" className="btn cta-primary mt-4">
                  Connect With Us
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="whyus" className="whyus-contact">
        <div className="container-fluid px-lg-5">
          <div className="row align-items-center">

            {/* LEFT SIDE — WHY CHOOSE US */}
            <div className="col-lg-6 pe-lg-5">
              <h2 className="fw-bold section-title mb-3 fade-up">
                Why Choose <span className="highlight">Varnam Solutions</span>
              </h2>
              <p className="section-subtitle fade-up mb-5">
                A women-led technology company blending innovation with empathy — we build
                systems that are as human as they are powerful.
              </p>

              <div className="whyus-list">
                <div className="whyus-item fade-up">
                  <span className="icon">👩‍💻</span>
                  <div>
                    <h5>Women-Led Vision</h5>
                    <p>Founded by <b>Suganya A</b> — where technology meets compassion and leadership.</p>
                  </div>
                </div>

                <div className="whyus-item fade-up">
                  <span className="icon">🚀</span>
                  <div>
                    <h5>Cloud & DevOps Excellence</h5>
                    <p>From AWS to CI/CD pipelines, we deliver scalable, automated, and secure platforms.</p>
                  </div>
                </div>

                <div className="whyus-item fade-up">
                  <span className="icon">🤝</span>
                  <div>
                    <h5>Reliable Partnership</h5>
                    <p>We value trust, transparency, and long-term growth with every client we work with.</p>
                  </div>
                </div>

                <div className="whyus-item fade-up">
                  <span className="icon">🛡️</span>
                  <div>
                    <h5>Secure & Scalable</h5>
                    <p>Our solutions are tested for performance, reliability, and data safety — always.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE — CONTACT FORM */}
            <div className="col-lg-6 ps-lg-5 mt-5 mt-lg-0">
              <div className="contact-card fade-up">
                <h4 className="mb-3">Let’s Build Something Great Together</h4>
                <p className="text-muted mb-4">
                  Tell us a bit about your project or business goal — we’ll reach out with ideas and a plan.
                </p>
                <form className="contact-form">
                  <input type="text" className="form-control" placeholder="Your Name" required />
                  <input type="email" className="form-control" placeholder="Your Email" required />
                  <input type="text" className="form-control" placeholder="Company / Organization" />
                  <textarea className="form-control" rows="3" placeholder="Message or Project Idea"></textarea>
                  <button type="submit" className="btn cta-primary w-100 mt-3">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container text-center text-md-start">
          <div className="row gy-4">
            <div className="col-md-4">
              <h5 className="fw-bold text-white">Varnam Solutions</h5>
              <p className="small text-white-50 mb-2">
                Empowering Businesses. Elevating Possibilities.
              </p>
              <p className="small text-white-50 mb-0">Women-led technology company from Tamil Nadu, India.</p>
            </div>

            <div className="col-md-4">
              <h6 className="fw-bold text-white">Office Address</h6>
              <p className="small text-white-50 mb-0">
                MuthuNagar, Theni, Tamil Nadu, India<br />
                <strong>Email:</strong> contact@varnamsolutions.com<br />
                <strong>Phone:</strong> +91 86374 35166
              </p>
            </div>

            <div className="col-md-4">
              <h6 className="fw-bold text-white">Follow Us</h6>
              <p className="small text-white-50">LinkedIn | Instagram | YouTube</p>
            </div>
          </div>
          <hr className="border-light opacity-25" />
          <div className="text-center small text-white-50">
            © {new Date().getFullYear()} Varnam Solutions. All rights reserved.
          </div>
        </div>
      </footer>


      {/* WHATSAPP */}
      <a className="whatsapp-btn" href={whatsappUrl} target="_blank" rel="noreferrer noopener" aria-label="Chat on WhatsApp" title="Chat with us on WhatsApp">
        <svg viewBox="0 0 24 24" width="26" height="26" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <path fill="#fff" d="M20.52 3.48A11.92 11.92 0 0012 0C5.373 0 .001 5.373.001 12.002a11.7 11.7 0 001.72 6.003L0 24l6.2-1.62A11.96 11.96 0 0012 24c6.627 0 12-5.373 12-11.998 0-3.206-1.25-6.22-3.48-8.522zM12 21.5c-1.3 0-2.57-.34-3.7-.98l-.26-.15-3.69.97.97-3.6-.17-.28A9.1 9.1 0 012.9 12C2.9 6.48 6.48 2.9 12 2.9S21.1 6.48 21.1 12 17.52 21.5 12 21.5z" />
          <path fill="#fff" d="M17.2 14.2c-.3-.2-1.7-.8-1.9-.9-.2-.1-.4-.1-.6.1-.2.2-.8.9-.9 1.2-.1.2-.2.3-.5.1-.3-.2-1.2-.45-2.3-1.4-.9-.8-1.4-1.9-1.6-2.2-.2-.3 0-.5.1-.7.1-.2.3-.6.5-.9.2-.3.1-.5 0-.7-.1-.2-.6-1.4-.9-1.9-.25-.5-.5-.4-.7-.4-.2 0-.5 0-.8 0-.3 0-.7.09-1 .45-.3.36-1.1 1.07-1.1 2.6 0 1.52 1.1 2.99 1.25 3.2.15.2 2.16 3.3 5.3 4.5 3.1 1.2 3.1.78 3.65.73.5-.05 1.7-.7 1.94-1.38.25-.68.25-1.26.175-1.38-.07-.12-.26-.19-.55-.34z" />
        </svg>
      </a>
    </div>
  );
}
